var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F7FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7915 92.3886V27.5286C23.7915 25.8902 24.4421 24.3189 25.6003 23.16C26.7585 22.0011 28.3295 21.3496 29.9679 21.3486H27.6507C26.0117 21.3486 24.4398 21.9997 23.2808 23.1587C22.1218 24.3177 21.4707 25.8896 21.4707 27.5286V92.388C21.4705 93.1996 21.6303 94.0033 21.9408 94.7532C22.2513 95.5031 22.7065 96.1844 23.2804 96.7583C23.8543 97.3322 24.5357 97.7874 25.2855 98.0979C26.0354 98.4084 26.8391 98.5682 27.6507 98.568H29.9685C29.1571 98.568 28.3537 98.4081 27.6041 98.0975C26.8545 97.7869 26.1735 97.3317 25.5998 96.7578C25.0262 96.184 24.5712 95.5028 24.2608 94.7532C23.9504 94.0035 23.7913 93.2 23.7915 92.3886Z",
    fill: "#143566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7915 92.3886V27.5286C23.7915 25.8902 24.4421 24.3189 25.6003 23.16C26.7585 22.0011 28.3295 21.3496 29.9679 21.3486H27.6507C26.0117 21.3486 24.4398 21.9997 23.2808 23.1587C22.1218 24.3177 21.4707 25.8896 21.4707 27.5286V92.388C21.4705 93.1996 21.6303 94.0033 21.9408 94.7532C22.2513 95.5031 22.7065 96.1844 23.2804 96.7583C23.8543 97.3322 24.5357 97.7874 25.2855 98.0979C26.0354 98.4084 26.8391 98.5682 27.6507 98.568H29.9685C29.1571 98.568 28.3537 98.408 27.6041 98.0975C26.8545 97.7869 26.1735 97.3317 25.5998 96.7578C25.0262 96.184 24.5712 95.5028 24.2608 94.7532C23.9504 94.0035 23.7913 93.2 23.7915 92.3886Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9691 21.3501H70.3137C71.1247 21.35 71.9278 21.5097 72.6771 21.82C73.4265 22.1303 74.1073 22.5852 74.6808 23.1587C75.2543 23.7322 75.7092 24.4131 76.0195 25.1624C76.3299 25.9117 76.4895 26.7148 76.4895 27.5259V92.3859C76.4897 93.1975 76.33 94.0012 76.0195 94.7511C75.709 95.501 75.2538 96.1824 74.6799 96.7563C74.106 97.3302 73.4246 97.7854 72.6747 98.0959C71.9248 98.4064 71.1211 98.5661 70.3095 98.5658H29.9691C29.1574 98.566 28.3538 98.4063 27.6039 98.0958C26.854 97.7852 26.1727 97.33 25.5988 96.7561C25.0249 96.1822 24.5697 95.5009 24.2592 94.751C23.9486 94.0012 23.7889 93.1975 23.7891 92.3859V27.5277C23.7891 25.8886 24.4402 24.3167 25.5991 23.1577C26.7581 21.9988 28.33 21.3477 29.9691 21.3477V21.3501Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.489 28.9912H23.791V90.9262H76.489V28.9912Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1406 92.9736C49.7901 92.9734 49.4475 93.0773 49.1561 93.272C48.8647 93.4667 48.6377 93.7436 48.5038 94.0674C48.3585 94.4185 48.3299 94.807 48.4223 95.1755C48.5147 95.5441 48.7232 95.8732 49.0169 96.1142C49.3107 96.3552 49.6741 96.4953 50.0536 96.5139C50.4331 96.5325 50.8085 96.4286 51.1244 96.2175C51.4404 96.0064 51.68 95.6993 51.808 95.3415C51.936 94.9838 51.9456 94.5944 51.8353 94.2308C51.725 93.8672 51.5007 93.5487 51.1956 93.3223C50.8904 93.0959 50.5206 92.9737 50.1406 92.9736Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8281 25.1709H54.4757",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8105 85.1055H66.1523",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8105 87.2559H66.1523",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0273 85.1055H48.3697",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0273 87.2559H48.3697",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8105 32.6543H66.1523",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8105 34.8047H66.1523",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6387 38.0264H66.1525",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6387 40.1768H66.1525",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6289 28.9912C33.6433 30.3047 34.1752 31.5594 35.1091 32.4831C36.043 33.4068 37.3035 33.9249 38.617 33.9249C39.9305 33.9249 41.1911 33.4068 42.1249 32.4831C43.0588 31.5594 43.5907 30.3047 43.6051 28.9912H33.6289Z",
    fill: "#143566"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6289 28.9912C33.6433 30.3047 34.1752 31.5594 35.1091 32.4831C36.043 33.4068 37.3035 33.9249 38.617 33.9249C39.9305 33.9249 41.1911 33.4068 42.1249 32.4831C43.0588 31.5594 43.5907 30.3047 43.6051 28.9912H33.6289Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.791 81.4014H76.489",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2577 63.1049H32.8857L39.7617 53.5505L36.7683 51.3965L25.6875 66.7931H39.2577V75.8135H42.9453V59.9201H39.2577V63.1049Z",
    fill: "#143566"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3802 59.9201V63.1049H64.0081L70.8841 53.5505L67.8907 51.3965L56.8105 66.7931H70.3802V75.8135H74.0683V59.9201H70.3802Z",
    fill: "#143566"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.821 55.895C55.8197 54.8959 55.4222 53.9381 54.7158 53.2318C54.0093 52.5254 53.0514 52.1281 52.0524 52.127H49.1358C48.1368 52.1282 47.1791 52.5256 46.4726 53.2319C45.7661 53.9383 45.3686 54.896 45.3672 55.895V72.0452C45.3683 73.0442 45.7656 74.002 46.472 74.7085C47.1784 75.415 48.1361 75.8125 49.1352 75.8138H52.053C53.0521 75.8126 54.0099 75.4152 54.7164 74.7087C55.4228 74.0022 55.82 73.0443 55.821 72.0452V55.895ZM52.1334 72.1256H49.0554V55.8146H52.1334V72.1256Z",
    fill: "#143566"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.791 44.5537L32.5744 48.5335L41.3572 44.5537H23.791Z",
    fill: "#FF7A21"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.791 44.5537L32.5744 48.5335L41.3572 44.5537H23.791Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3574 44.5537L50.1402 48.5335L58.923 44.5537H41.3574Z",
    fill: "#FF7A21"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3574 44.5537L50.1402 48.5335L58.923 44.5537H41.3574Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9219 44.5537L67.7059 48.5335L76.4887 44.5537H58.9219Z",
    fill: "#FF7A21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9219 44.5537L67.7059 48.5335L76.4887 44.5537H58.9219Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5732 62.96L92.6704 69.68L85.7104 69.1268L82.753 75.452L75.793 74.8994L72.613 81.116L65.6758 80.318C68.3327 84.6667 71.8783 88.4052 76.0804 91.2884C80.2825 94.1717 85.0463 96.1347 90.0598 97.049L117.501 77.8706C108.932 76.016 100.07 70.4828 95.5732 62.96Z",
    fill: "#FF7A21"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5732 62.96L92.6704 69.68L85.7104 69.1268L82.753 75.452L75.793 74.8994L72.613 81.116L65.6758 80.318C68.3327 84.6667 71.8783 88.4052 76.0804 91.2884C80.2825 94.1717 85.0463 96.1347 90.0598 97.049L117.501 77.8706C108.932 76.016 100.07 70.4828 95.5732 62.96Z",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3398 81.4523L102.828 80.7695",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8133 73.3936L91.5879 88.486",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3828 42.9883H97.3924",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3867 45.9936V39.9834",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 73.876L14.5057 78.1258",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 78.1258L14.5057 73.876",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8398 97.4824L102.008 99.6502",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8398 99.6502L102.008 97.4824",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 95.0441L5.3582 98.1083L7.5434 93.5303",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M100.924 27.6318H104.202",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M102.562 29.2706V25.9922",
    stroke: "#143566",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.89b344ae6ad366784ff0a98cc0691b5c.svg";
export { ForwardRef as ReactComponent };